import { UIIcon } from '../../../config/icons';
import { $trigger } from '../../y/events';
import { uiInitDropTarget } from '../dnd';
import { $el } from '../elements';
import { uiMakeFakeUploadInput } from '../functions';
import { UIBaseInput, UIBaseInputOptions } from './input-base';

export interface UIFileInputOptions extends UIBaseInputOptions {
    accept: string[];
    multiple?: boolean;
}

export class UIFileInput extends UIBaseInput<File[]> {
    private _placeholder: string;
    private _upload_input: HTMLInputElement;
    private _value!: File[];
    private _multiple: boolean | undefined;

    constructor(options: UIFileInputOptions) {
        options.r_deco = $el.ICON(UIIcon.ELLIPSIS_STROKE, 'r-arrow');
        const input = $el.DIV();
        super(options, input);
        this.classList.add('ui-select');
        input.tabIndex = 0;

        input.addEventListener('blur', () => {
            this.classList.remove('f-focus');
            $trigger(this, 'blur');
        });

        input.addEventListener('focus', () => {
            this.classList.add('f-focus');
            $trigger(this, 'focus');
        });

        this._placeholder = options.placeholder || '\u00a0';
        this._upload_input = uiMakeFakeUploadInput(files => { this.value = Array.from(files) }, options.accept, options.multiple);

        this.root.addEventListener('click', () => { this.openPicker(); });

        this._multiple = options.multiple;

        this.value = [];

        uiInitDropTarget(this, {
            drop: c => {
                if(c.type === 'files') {
                    this.value = c.value;
                }
            },
            dropEnter: () => true
        });

    }

    openPicker() {
        if(this.disabled) return;

        this.input_elem.focus();
        this._upload_input.click();
    }

    protected fixText() {
        const v = this._value;

        let text: string;

        if(!v.length) {
            this.input_elem.classList.add('f-placeholder');
            text = this._placeholder;
        } else {
            this.input_elem.classList.remove('f-placeholder');
            text = this._value.map(f => f.name).join(', ');
        }

        this.input_elem.textContent = text || '\u00a0';
    }

    override focus() {
        this.input_elem.focus();
    }

    protected doCheck() {
        this.setOkay(!this.required || !this.is_empty);
    }

    get value(): File[] {
        return this._value;
    }

    set value(value: File[]) {
        value = value || [];
        if(!this._multiple && value.length > 1)
            value = [value[0]];

        this._value = value;

        this.fixText();
        this.doCheck();
        this.fixDesign();

        $trigger(this, 'value', this._value);
    }

    get is_empty() {
        return !this._value.length;
    }
}
